export default "__VITE_ASSET__3j6uzlMB__"